import { render, staticRenderFns } from "./ClickIcon.vue?vue&type=template&id=df7bf6ac&"
import script from "./ClickIcon.vue?vue&type=script&lang=js&"
export * from "./ClickIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports